import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { Tooltip } from "react-tooltip";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
interface WaveDropRatingsProps {
  readonly drop: ApiDrop;
}
const WaveDropRatings: React.FC<WaveDropRatingsProps> = t0 => {
  const $ = _c(30);
  const {
    drop
  } = t0;
  let borderStyle = "tw-border-iron-700";
  let bgStyle = "tw-bg-iron-900/40";
  const yourVotes = drop?.context_profile_context?.rating ?? 0;
  const hasVoted = yourVotes !== 0;
  const hasUpvoted = yourVotes > 0;
  if (hasVoted) {
    borderStyle = "tw-border-primary-500";
    bgStyle = "tw-bg-primary-500/10";
  }
  const t1 = `tw-inline-flex tw-items-center tw-gap-x-2 tw-mt-1 tw-py-1 tw-px-2 tw-rounded-lg tw-shadow-sm tw-border tw-border-solid ${borderStyle} ${bgStyle}`;
  let t2;
  if ($[0] !== drop.top_raters) {
    t2 = drop.top_raters.map(_temp);
    $[0] = drop.top_raters;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="tw-flex tw-items-center -tw-space-x-2">{t2}</div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== drop.raters_count) {
    t4 = formatNumberWithCommas(drop.raters_count);
    $[4] = drop.raters_count;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = drop.raters_count === 1 ? "voter" : "voters";
  let t6;
  if ($[6] !== t5) {
    t6 = <span className="tw-text-iron-500 tw-font-normal">{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <span className="tw-text-iron-200 tw-font-semibold tw-text-sm">{t4}{" "}{t6}</span>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-2">{t3}{t7}</div>;
    $[11] = t3;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== drop.id || $[15] !== drop.raters_count || $[16] !== drop.rating) {
    t9 = drop.raters_count > 0 && <><span className="tw-text-iron-900 tw-text-xs tw-font-medium tw-bg-iron-500 tw-px-2 tw-py-0.5 tw-rounded-full" data-tooltip-id={`total-rating-${drop.id}`}>{formatNumberWithCommas(drop.rating)}{" "}</span><Tooltip id={`total-rating-${drop.id}`} style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px"
      }}>Total</Tooltip></>;
    $[14] = drop.id;
    $[15] = drop.raters_count;
    $[16] = drop.rating;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== drop.id || $[19] !== hasUpvoted || $[20] !== hasVoted || $[21] !== yourVotes) {
    t10 = hasVoted && <div className={`${hasUpvoted ? "tw-bg-green/20" : "tw-bg-red/20"} tw-ml-2 tw-rounded-full tw-h-4 tw-min-w-4 tw-flex tw-items-center tw-justify-center tw-transition tw-ease-out tw-duration-300`}><><span className={`${hasUpvoted ? "tw-text-green" : "tw-text-error"} tw-text-xs tw-font-normal`} data-tooltip-id={`your-votes-${drop.id}`}>{formatNumberWithCommas(yourVotes)}</span><Tooltip id={`your-votes-${drop.id}`} style={{
          backgroundColor: "#1F2937",
          color: "white",
          padding: "4px 8px"
        }}>Your given likes</Tooltip></></div>;
    $[18] = drop.id;
    $[19] = hasUpvoted;
    $[20] = hasVoted;
    $[21] = yourVotes;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <div className="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-iron-500 tw-text-xs tw-font-normal">{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t1 || $[27] !== t11 || $[28] !== t8) {
    t12 = <div className={t1}>{t8}{t11}</div>;
    $[26] = t1;
    $[27] = t11;
    $[28] = t8;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};
export default WaveDropRatings;
function _temp(rater) {
  return <div key={rater.profile.id}>{rater.profile.pfp ? <img src={getScaledImageUri(rater.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${rater.profile.handle}'s avatar`} className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" data-tooltip-id={`rater-${rater.profile.id}`} /> : <div className="tw-w-6 tw-h-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" data-tooltip-id={`rater-${rater.profile.id}`} />}<Tooltip id={`rater-${rater.profile.id}`} style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>{rater.profile.handle} - {rater.rating}</Tooltip></div>;
}